import { render, staticRenderFns } from "./SubmitRequestView.vue?vue&type=template&id=5323744a"
import script from "./SubmitRequestView.vue?vue&type=script&lang=js"
export * from "./SubmitRequestView.vue?vue&type=script&lang=js"
import style0 from "./SubmitRequestView.vue?vue&type=style&index=0&id=5323744a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports